import { useSelector } from 'react-redux';
import SlideCard from '../common/SlideCard';

export function SellerOperatorCommission() {
  const { commission } = useSelector((state) => state.operators.configuration);

  return (
    <SlideCard
      title="Operator Commission"
      description="The commission rate that the seller will be billed per order, excluding shipping and applied after any discounts."
    >
      {commission ? `${commission}%` : 'No Commission'}
    </SlideCard>
  );
}
